module.exports = __webpack_public_path__ + "img/artboard_bk_3.dcd57f6d.png";